import { APIRoute } from '@/modules/utils'
import { DisponibilityChoice } from '@/data'
import { HydraCollection } from 'emt-library'

export type Response = HydraCollection<DisponibilityChoice>

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/disponibility_choices',
}
